import { render, staticRenderFns } from "./ChangePackage.vue?vue&type=template&id=85162e74&scoped=true&"
import script from "./ChangePackage.vue?vue&type=script&lang=js&"
export * from "./ChangePackage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePackage.vue?vue&type=style&index=0&id=85162e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85162e74",
  null
  
)

export default component.exports